import moment from 'moment';
import utils from 'utils';
import rest from "../Rest";

export const saveModel = (modelToSave, stepToSave) => {
  const modelSaved = modelToSave;
  modelSaved.stepID = stepToSave;
  localStorage.setItem('model', JSON.stringify(modelSaved));
};
export const saveDataList = (dataList) => {
  localStorage.setItem('dataList', JSON.stringify(dataList));
};
export const generateB2SeeToken = async (idnumber, visitorKey) => {
  const { rest } = utils;


  const t = await rest.get(`/api/Manager/GenerateB2SeeToken?idnumber=${idnumber}&visitorKey=${visitorKey}`);
   
  
}
export const postData = async (model, setStep) => {
  const { rest } = utils;


    rest.post('/api/Manager/PostData', {
      data: model,
    })
    .then(res => {
      if (res.data === 'ok') {
        setStep(model.stepID);
        saveModel(model, model.stepID);

      }
    });
  
}

export const uploadFilesToBack = (filesMapUpload) => {

  if (filesMapUpload) {
    const formData = new FormData();
    const filesMap = filesMapUpload; // filesMap structure: { [fileTypeID]: {file: InputFile, fileName: string} }
    for (const key in filesMap) {
      const value = filesMap[key];
      formData.append("File", value);
      formData.append("FileTypeIDList", parseInt(key));
    }
    return rest.post('/api/Manager/UploadToBack', {
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

  }
  else {
    return true;
  }
}

export function getAge(dateString) {
  const today = new Date();
  const date = moment(dateString, 'DD-MM-YYYY');
  const birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}


export function setDataLayer(event,actionScreen,processLevel,actionName){
  window.dataLayer.push({
    event: event,
    eventInfo: {
      action_screen: actionScreen,
      process_level: processLevel,
      action_name: actionName,
    },
  });
}
